<p>Signing out user</p>
